module.exports = __webpack_public_path__ + "static/media/header_logo2.a46a0b6e.png";